import './SuccessfulPayment.scss';
import { ReactComponent as SuccessIcon } from '../../assets/v3/payment_success.svg';

const SuccessfulPayment = (props: { action: Function, productId: string }) => {

  return (
    <div className="hp-successfulPayment">
      <SuccessIcon />
      {props.productId.indexOf('donation_') > -1 ? (<>
        <div className="hp-successfulPayment__info">VOTRE DONATION A BIEN ÉTÉ VALIDÉ !</div>
        <div className="hp-successfulPayment__thanks">
          Nous vous remercions pour votre soutien et nous espérons vous compter encore longtemps parmi nos mécènes incha Allah !
        </div>
      </>) : (<>
        <div className="hp-successfulPayment__info">VOTRE PAIEMENT A ÉTÉ VALIDÉ !</div>
        <button className="hp-successfulPayment__btn" onClick={() => props.action()}>CONSULTER LE CONTENU</button>
        <div className="hp-successfulPayment__thanks">Merci ! En achetant du contenu vous financez le développement de la plateforme.</div>
      </>)}
    </div>
  );
};

export default SuccessfulPayment;
